import { render, staticRenderFns } from "./BasePopupSpinner.vue?vue&type=template&id=b7d35124&"
import script from "./BasePopupSpinner.vue?vue&type=script&lang=ts&"
export * from "./BasePopupSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports